import React, { useEffect, useState } from 'react';
import { t } from '../common/i18n';
import { Header, Content, Text, SubscriptionModal } from '../common/components';
import { useDocumentTitle, useAppSelector } from '../common/hooks';
import { selectSecurity } from '../common/store/securitySlice';
import RegistryDashboard from './components/dashboard/RegistryDashboard';
import RegistryLastCheck from './components/lastCheck/RegistryLastCheck';
import BuildingLogsTimeline from './components/buildingLog/BuildingLogsTimeline';
import TimelineEmptyState from './components/buildingLog/TimelineEmptyState';
import MonitoringNotificationSettings from './components/settings/MonitoringNotificationSettings';
import { registryData, updateRegistryDataWithBuildingInfo, RegistryDataItem } from './config/registryData';
import { getRegistryBuildingInfo } from './services/RegistryService';

export const Registry: React.FC = () => {
  useDocumentTitle(t('Registry.title'));
  const security = useAppSelector(selectSecurity).ui;
  const hasSubscription = security.tokens?.filter((item) => item.type === 'building-subscription').length || 0;
  const shouldShowModal = !hasSubscription;

  const [currentRegistryData, setCurrentRegistryData] = useState<RegistryDataItem[]>(registryData);
  const [plannedChecks, setPlannedChecks] = useState<string[]>([]);

  useEffect(() => {
    const loadBuildingLogInfo = async () => {
      try {
        const buildingLogInfo = await getRegistryBuildingInfo();
        const updatedData = updateRegistryDataWithBuildingInfo({
          ...buildingLogInfo,
          address: security.address,
        });
        setCurrentRegistryData(updatedData);
        setPlannedChecks(buildingLogInfo.plannedChecks ?? []);
      } catch (error) {
        console.error('Error loading building info:', error);
      }
    };

    loadBuildingLogInfo();
  }, [security.address]);

  return (
    <>
      <Header title={t('Registry.title')} backlink={-1} />

      <Content className="Content Registry">
        <RegistryDashboard registryData={currentRegistryData} />

        <Text size="h2" color="Neutral800" className="mt-3 mb-3">
          {t('Registry.lastCheckTitle')}
        </Text>

        <RegistryLastCheck plannedChecks={plannedChecks} />

        <Text size="h2" color="Neutral800" className="mt-3 mb-3">
          {t('Registry.historyOfControlTitle')}
        </Text>

        <div className="timeline-container">
          <div className={shouldShowModal ? 'blur-content timeline-locked' : ''}>
            <BuildingLogsTimeline
              emptyState={
                <TimelineEmptyState title={t('Registry.history.emptyTitle')} text={t('Registry.history.emptyText')} />
              }
            />
          </div>
          {shouldShowModal && <SubscriptionModal />}
        </div>

        {/* Dole pod historií – starší roky jsou sbalené, takže konec stránky je dosažitelný.
            Mimo paywall blur – odhlásit e-maily musí jít i bez licence (nudge e-maily chodí všem). */}
        <MonitoringNotificationSettings />
      </Content>
    </>
  );
};

export default Registry;
